/* @flow */

import React from 'react';
import { canDownloadEntities } from 'containers/decorators';
import { spinnable } from 'components/UIKit/decorators';
import Button from 'components/UIKit/Button/ButtonTemplate';
import DownloadIcon from 'components/icons/DownloadIcon';
import { Spinner } from 'components/UIKit/Spinner';
import { setMessage } from 'ducks/message';
// $FlowIgnore
import { connect } from 'react-redux';
import Row from 'components/UIKit/Flex/Row';

export type DataFilesManifestsDownloadContainerType = {
  dispatch: () => {},
  setIsSpinning: () => {},
  isSpinning: boolean,
  downloadAllManifest: () => {},
  downloadManifestByIds: () => {},
  dataFilesIds: Array<string>,
  downloadAllOfType: string,
  filename: string,
  children: any,
  customDataTestID?: string
}

function DataFilesManifestsDownloadContainer({
  dispatch,
  setIsSpinning,
  isSpinning,
  downloadAllManifest,
  downloadManifestByIds,
  dataFilesIds,
  downloadAllOfType,
  filename,
  children,
  customDataTestID,
}: DataFilesManifestsDownloadContainerType): React.Element {
  return (
    <Row>
      <Button
        customDataTestID={customDataTestID}
        disabled={isSpinning || (!downloadAllOfType && !(dataFilesIds || []).length)}
        onClick={async () => {
          setIsSpinning(true);
          try {
            if (downloadAllOfType) {
              await downloadAllManifest(downloadAllOfType, filename);
            } else await downloadManifestByIds(dataFilesIds, '', filename);
          } catch (err) {
            dispatch(setMessage('Error manifest'));
          }
          setIsSpinning(false);
        }}
        PrefixComponent={isSpinning
          ? <Spinner style={{ height: '1rem', width: '1rem', marginRight: '2px' }} />
          : <DownloadIcon />}
        >
        {children}
      </Button>
    </Row>
  );
}

export default connect()(canDownloadEntities(spinnable(DataFilesManifestsDownloadContainer)));
